<div class="modal-header">
    <h4 class="modal-title fw-bold" jhiTranslate="inventoryManagerApp.lot.import.deposits.mapping.title">Select Mapping</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="closed()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="row mb-3">
            <label class="col-5 col-form-label">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.import.deposits.mapping.lotUID">Please specify the header for LOT UID</label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownLotUID" id="dropdownLotUID" [(ngModel)]="lotUIDMapping" required>
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-5 col-form-label">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.import.deposits.mapping.amount">Please specify the header for AMOUNT</label>
            </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownAmount" id="dropdownAmount" [(ngModel)]="amountMapping" required>
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row mb-3">
            <label class="col-5 col-form-label">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.import.deposits.mapping.notes">Please specify the header for NOTES</label> </label>
            <div class="col-4">
                <div class="mb-3 row">
                    <select class="form-select" name="dropdownNotes" id="dropdownNotes" [(ngModel)]="notesMapping">
                        <option value="" jhiTranslate="global.please.choose">Please Choose</option>
                        <option *ngFor="let item of header" [value]="item">{{item}}</option>
                    </select>
                </div>
                <div class="form-check" *jhiHasAnyAuthority="CONFIRM_DEPOSIT_INVENTORY_PERMISSION">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="confirmDepositTransactions.selected" name="depositAvailable" id="depositAvailable">
                    <label class="form-check-label" for="depositAvailable" jhiTranslate="inventoryManagerApp.lot.import.deposits.confirm">Confirm deposits</label>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()"><span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.back">Back</span>
    </button>
    <button type="button" (click)="proceed()" [disabled]="f.form.invalid" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.proceed">Proceed</span>
    </button>
</div>
